import {DceAjaxAction} from "dce-ajax";
import {OpenModal} from "app";
import {createDomElementFromString} from "app/lib/utils/createDomElementFromString";

interface ReplaceElementData {
    elements: {
        element: string,
        selector: string
    }[];
}

export default class DceAjaxReplaceElementAction implements DceAjaxAction {

    execute(data: any): void {
        let arr = data as ReplaceElementData;

        arr.elements.forEach(d => {
            document.querySelectorAll(d.selector).forEach(elem => {
                let element = createDomElementFromString(d.element);
                elem.replaceWith(element);
            });
        });

    }

    getPriority(): number {
        return 0;
    }

}